<template>
  <div class="row blaLingronContainer">
    <ProgressBar
      :current-position="currentPosition"
      :max-position="maxPosition"
      :fixed-header="true"
    />
    <div class="col-10 offset-1">
      <div class="row my-5">
        <div class="col-2 text-right">
          <img
            :src="require('@/assets/img/exclamation_mark_icon.png')"
            alt="exclamation_mark_icon"
            class="blaExlaminationIcon"
          />
        </div>
        <div class="col-10 blaLingronTitle">Gépeld be a helyes megoldást.</div>
      </div>

      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        duration="750"
      >
        <div>
          <div class="row">
            <div class="col-12 mt-3 text-center">
              <img
                :src="require('@/assets/img/bla_play_button.png')"
                alt="play_button"
                class="blaLingronPlayButton clickable"
                :class="{ pulsePlayButton: playedNow }"
                @click="playSound(lingron.file)"
              />
            </div>
          </div>
          <div
            v-show="showQuestion"
            class="row mt-5 mb-2 p-2 text-center blaLingronTextBoxFull"
          >
            <div
              class="col-12"
              v-if="lingron.other_lang"
              v-html="lingron.other_lang"
            ></div>
            <div class="col-10 offset-1">
              <hr class="blaHr-test" />
            </div>
            <div
              class="col-12 lingronTestHint"
              v-html="lingron.main_lang"
            ></div>
            <div class="col-12 text-right">
              <div
                class="lingronSpecialCharacterButton animatedButton"
                data-value="'"
              >
                '
              </div>
              <div
                class="lingronSpecialCharacterButton animatedButton"
                data-value="ä"
              >
                ä
              </div>
              <div
                class="lingronSpecialCharacterButton animatedButton"
                data-value="ß"
              >
                ß
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated slideOutLeft"
        duration="750"
      >
        <div v-show="checkAnswers" class="row mt-4 mb-2 mt-5 align-center">
          <div class="col-12 col-md-4 offset-md-4 text-center">
            <div
              class="blaLingronNextButton animatedButton"
              @click="checkInputs"
            >
              Ellenőrzés
            </div>
          </div>
        </div>
      </transition>

      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated slideOutLeft"
        duration="750"
      >
        <div v-show="showNext" class="row mt-4 mb-2 mt-5 align-center">
          <div class="col-12 col-md-4 offset-md-4 text-center">
            <div class="blaLingronNextButton animatedButton" @click="loadNext">
              Következő
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>



<script>
import axios from "axios";
import $ from "jquery";
import { setTimeout } from "timers";
import { mapGetters } from "vuex";
import ProgressBar from "@/components/partials/ProgressBar";

import "@/assets/testCheck";
import { type } from "os";

export default {
  components: {
    ProgressBar,
  },
  data: function () {
    return {
      // lessonId: this.$route.params.lessonId, //For dev
      lessonId: this.$store.getters.currentLessonId,
      questions: {},
      lingron: {},
      lastLingronId: this.$store.getters.lastLingronId,
      clickCounter: 0,
      localCounter: 0,
      questionCounter: 0,
      currentPosition: 0,
      maxPosition: 0,
      checkAnswers: false,
      showNext: false,
      showQuestion: false,
      soundFileDuration: 3000,
      playedNow: false,
      playedFile: "",
      missed: false,
    };
  },
  methods: {
    getLingronTestData() {
      this.showQuestion = false;

      axios
        .post(this.$store.getters.getApiUrl + "/api/lingron/test", {
          token: this.$store.getters.getToken,
          lessonId: this.$data.lessonId,
          lastLingronId: this.lastLingronId,
        })
        .then((response) => {
          // console.log('lingron - test - resp: ', response.data);
          this.questions = response.data.questions;
          this.lingron = response.data.lingron;
          this.currentPosition = response.data.currentPosition;
          this.maxPosition = response.data.maxPosition;
          this.questionCounter = response.data.questionCounter;
          this.clickCounter = 0;

          //Store last lingron ID
          this.$store.commit("updateLastLingronId", {
            lastLingronId: response.data.lingron.id,
          });

          //Store linfron last state
          this.$store.commit("updateLastLingron", {
            lastLingron: response.data.lingron.last,
          });

          let v = this;
          setTimeout(function () {
            v.showQuestion = true;
            v.checkAnswers = true;
          }, 1000);
        })
        .catch((error) => {
          console.log("lingron - test - error: ", error);
        });
    },
    loadNext() {
      console.log("move next - call stopSound");

      //Stop the played file if it is already playing
      this.stopSound();

      //TestMini check
      if (this.lingron.mini_lingrons && this.lingron.mini_lingrons.length > 1) {
        //Store came from lingron page
        this.$store.commit("updateFromLingron", {
          fromLingron: true,
        });

        this.$router.push({
          name: "testMini",
          params: {
            lessonId: this.lingron.lesson_id,
            lingronId: this.lingron.id,
          },
        });
      } else {
        this.lastLingronId = this.$store.getters.lastLingronId;
        this.checkAnswers = false;
        this.showQuestion = false;
        this.showNext = false;
        // this.getLingronTestData();

        let v = this;
        setTimeout(() => {
          v.getLingronTestData();
        }, 1000);
      }
    },
    checkInputs() {
      //Stop the played file if it is already playing
      this.stopSound();

      this.localCounter = 0; //Set 0, because every check we count again
      this.clickCounter++;

      this.questions.forEach((question) => {
        let userAnswer = $("#question-input-" + question.id);
        let userAnswerValue = userAnswer.val();
        let missed = userAnswer.data("missed");

        //remove all indicator class
        userAnswer.removeClass("lingronTestInputGood");
        userAnswer.removeClass("lingronTestInputWrong");

        //Check he messed it up once
        if (!missed) {
          //check answer
          if (
            question.answer === userAnswerValue ||
            question.answer2 === userAnswerValue
          ) {
            this.questions[question.id].good_solution = true;
            this.localCounter++;
            userAnswer.addClass("lingronTestInputGood");
            userAnswer.val(question.original);
          } else {
            this.questions[question.id].wrong_solution = true;
            userAnswer.addClass("lingronTestInputWrong");
            userAnswer.val(question.original);
            userAnswer.data("missed", true);

            setTimeout(() => {
              userAnswer.val("");
              userAnswer.data("missed", false);
            }, 3000);
          }
        } else {
          userAnswer.addClass("lingronTestInputWrong");
        }
      });

      //Play soundfile
      this.playSound(this.lingron.file);

      //Check all answer is good
      if (this.questionCounter === this.localCounter) {
        //If it is the first check we give user points
        if (this.clickCounter === 1) {
          this.$store.dispatch("goodAnswerEarned");
        } else {
          this.$store.commit("addItemIncorrectAnswer", {
            id: this.lingron.id,
            type: "Lingron",
          });
        }

        //Show the next button & hide the check button
        this.checkAnswers = false;
        let v = this;
        setTimeout(function () {
          v.showNext = true;
        }, 1000);
      }
    },
    playSound(file) {
      if (file) {
        //Play the audio file
        let sound =
          this.$store.getters.getApiUrl + "/uploads/sound/" + file.filename;

        //Create audio object
        let audio = new Audio(sound);

        audio.load();
        console.log("sound - loaded");

        if (!this.playedNow) {
          this.playedNow = true;
          this.playedFile = audio;

          //Play sound
          audio.play();
          console.log("sound - played", typeof audio);

          let v = this;
          setTimeout(function () {
            v.playedNow = false;
            v.voiceShow = false;
            v.showLingrons = true;
            v.lingronClick = true;
            v.enableClick = true;
          }, this.soundFileDuration);
        }
      }
    },
    stopSound() {
      if (this.playedFile !== null && typeof this.playedFile == "object") {
        this.playedFile.pause();
        this.playedFile = null;
      }
    },
  },
  computed: {
    ...mapGetters[("lastLingronId", "incorrectAnswers")],
  },
  mounted: function () {
    this.showQuestion = false;
    this.lastLingronId = this.$store.getters.lastLingronId;

    this.$store.commit("updateLastMiniLingronId", {
      lastMiniLingronId: null,
    });

    this.getLingronTestData();
  },
};
</script>
